<template>
  <div class="r-choose-address-modal common-hover">
    <Modal footer-hide v-model="show" width="652">
      <div class="password-box">
        <div class="titile">{{ $t("underProduction.another") }}</div>
        <div style="height: 320px; overflow-y: auto" class="common-rowUnder">
          <div
            v-for="(item, index) in addressList"
            :key="index"
            @click="chooseAddress(item)"
            :style="[addressId == item.id ? { background: '#fff' } : {}]"
            class="address-item common-flex common-align-center common-hover"
            :class="addressId == item.id  ? 'chosoe' : ''"
          >
            <img class="logo" :src="item.expressUrl" alt="" />
            <div
              class="common-flex common-direction-column common-justify-between"
            >
              <div class="name">{{ item.contact }}</div>
              <div class="common-flex address">
                <div>{{ item.phone }}</div>
                <div style="margin: 0 5px">|</div>
                <div class="address-details">
                  {{ item.address }}
                </div>
              </div>
              <div class="user">
                {{ item.expressName }} | {{ item.expressTypeName }} |
                {{ item.payTypeName }}
              </div>
            </div>
            <Icon
              v-if="addressId == item.id "
              style="font-size: 20px; margin-left: 10px; color: #0075e7"
              type="ios-checkmark-circle"
            />
          </div>
        </div>
        <div class="common-flex common-justify-center" style="margin-top: 60px">
          <div class="back common-hover" @click="back">
            {{ $t("underProduction.back") }}
          </div>
          <div class="submit common-hover" @click="submit">
            {{ $t("underProduction.submit") }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "r-choose-address-modal",
  data() {
    return {
      addressId: "",
      show: false,
      addressList: [],
    };
  },
  watch: {
    addressShow: {
      handler(newval, oldval) {
        "newval", newval;
        this.show = newval;
      },
      immediate: true,
    },
    // submitAddress: {
    //   handler(newval, oldval) {
    //     console.log('this.addressId',this.newval)

    //   },
    //   immediate: true,
    //   deep:true
    // },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handlerAddressShow", newval);
        } else {
          if (this.submitAddress) {
            this.addressId = this.submitAddress.id;
          }
          this.getaddressList();
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions([
      "addressListAction", //地址列表
    ]),
    back(){
      this.$emit('back')
    },
    submit(){
      this.$emit('submit',this.addressId)
    },
    // 获得地址列表
    getaddressList() {
      this.addressListAction().then((res) => {
        this.addressList = res.data;
      });
    },
    // 选择地址
    chooseAddress(item) {
      this.addressId = item.id;
    },
  },
  props: {
    addressShow: Boolean,
    submitAddress: [String, Object],
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.password-box {
  height: 500px;
  width: 627px;
  padding: 14px 24px;
  font-family: Roboto;
  .titile {
    font-size: 30px;
    font-family: Times, Times-Bold;
    font-weight: 700;
    text-align: left;
    color: #000000;
    line-height: 37px;
    margin-bottom: 30px;
  }
  .address-item {
    width: 572px;
    height: 95px;
    padding: 15px;
    background: #f8f8f8;
    margin-bottom: 10px;
    border-radius: 4px;
    margin-right: 7px;
  }
  .chosoe {
    position: relative;
  }
  .chosoe::after {
    content: "";
    position: absolute;
    width: 572px;
    height: 95px;
    border: 1px solid #0075e7;
    top: 0;
    left: 0;
  }
  .user {
    font-size: 12px;
    font-weight: 400;
    text-align: left;
    color: #0a4dcc;
    line-height: 14px;
  }
  .name {
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    color: #081938;
    line-height: 19px;
  }
  .address {
    opacity: 0.7;
    font-size: 12px;
    font-family: Roboto;
    font-weight: 400;
    text-align: left;
    color: #081938;
    line-height: 14px;
    margin: 8px 0;
  }
  .address-details {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 340px;
  }
  .logo {
    width: 65px;
    height: 65px;
    display: block;
    background: #f8c604;
    border-radius: 4px;
    margin-right: 16px;
  }
  .back,
  .submit {
    width: 116px;
    height: 40px;
    background: #b5bac4;
    line-height: 40px;
    font-size: 14px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
  .submit {
    background: #0a4dcc;
    margin-left: 14px;
  }

  .cancel-tip {
    font-size: 20px;
    font-family: Roboto, Roboto-Medium;
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 24px;
    margin: 30px 0 60px 36px;
  }
}
// }
</style>


// WEBPACK FOOTER //
// src/components/r-choose-address-modal.vue